class Drawer extends HTMLElement {
  constructor() {
    super();
    this.animationDuration =
      this.getAttribute("data-animation-duration") || 400;

    if (typeof this.animationDuration == "string") {
      this.animationDuration = parseInt(this.animationDuration);
    }

    this.isSubDrawer = this.getAttribute("data-subddrawer");
    this.isInMovement = false;

    this.closeOnEscNamed = this.closeOnEsc.bind(this);
    this.closeOnBlurNamed = this.closeOnBlur.bind(this);

    this.blurNodeTypes = ["BODY", "CART-DRAWER", "DRA-WER"];
  }

  setDrawerTargets() {
    this.querySelectorAll("drawer-control").forEach((elem) => {
      if (!elem.hasAttribute("for")) {
        elem.setAttribute("for", this.getAttribute("id"));
      }
    });
  }

  closeOnBlur(event) {
    if (this.blurNodeTypes.includes(event.target.nodeName)) {
      this.closeDrawer();
    }
  }

  closeOnEsc(event) {
    if (event.keyCode == 27) {
      this.closeDrawer();
    }
  }

  bindWindowEvents() {
    window.addEventListener("keydown", this.closeOnEscNamed);
    window.addEventListener("click", this.closeOnBlurNamed);
  }

  unbindWindowEvents() {
    window.removeEventListener("keydown", this.closeOnEscNamed);
    window.removeEventListener("click", this.closeOnBlurNamed);
  }

  isMoving() {
    this.isInMovement = true;
    this.setAttribute("is-moving", "");

    setTimeout(() => {
      this.removeAttribute("is-moving");
      this.isInMovement = false;
    }, this.animationDuration);
  }

  closeDrawer() {
    this.isMoving();
    this.removeAttribute("open");

    if (!this.isSubDrawer) {
      this.unbindWindowEvents();
      document.body.classList.remove("fade-body");
    }
  }

  openDrawer() {
    this.isMoving();
    this.setAttribute("open", "");

    if (!this.isSubDrawer) {
      this.bindWindowEvents();
      document.body.classList.add("fade-body");
    }
  }

  addAnimationClass() {
    if (!this.classList.contains("allow-modal-transition")) {
      this.classList.add("allow-modal-transition");
    }
  }

  connectedCallback() {
    this.addAnimationClass();
    this.setDrawerTargets();
  }
}

class DrawerControl extends HTMLElement {
  constructor() {
    super();

    this.action = this.getAttribute("action") || "close";
    this.drawerTarget = document.querySelector(
      ".js-drawer#" + this.getAttribute("for")
    );
  }

  onInteraction() {
    if (this.action == "close") {
      this.drawerTarget.closeDrawer();
    }
    if (this.action == "open") {
      this.drawerTarget.openDrawer();
    }
  }

  listenForInteraction() {
    this.addEventListener("click", this.onInteraction);
  }

  connectedCallback() {
    this.listenForInteraction();
  }
}

customElements.define("dra-wer", Drawer);
customElements.define("drawer-control", DrawerControl);

class SearchModal extends Drawer {
  constructor() {
    super();
  }

  openDrawer() {
    super.openDrawer();
    this.searchInput.focus();
  }

  connectedCallback() {
    this.searchInput = this.querySelector('search-form input[name="q"]');
  }
}

customElements.define("search-modal", SearchModal);

class BISModal extends Drawer {
  constructor() {
    super();
  }

  bisSignup() {
    this.cacheFormData();
    var variantId = "$shopify:::$default:::" + this.formData.get("variant");
    var userEmail = this.formData.get("email");
    var companyId = this.formData.get("company_id");
    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=" +
        companyId,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-02-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: { email: userEmail },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: variantId,
                },
              },
            },
          },
        }),
      }
    )
      .then((response) => {
        this.form.classList.remove("bisform--error");
        this.form.classList.remove("bisform--submitted");

        if (response.ok) {
          this.form.classList.add("bisform--submitted");
        } else {
          this.form.classList.add("bisform--error");
        }
      })
      .catch((err) => {});
  }

  newslettermailSignup() {
    this.cacheFormData();
    var userEmail = this.formData.get("email");
    var listId = this.formData.get("list_id");

    fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" +
        this.formData.get("company_id"),
      {
        method: "POST",
        headers: {
          revision: "2024-02-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "bis-signup",
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: userEmail,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: { type: "list", id: listId },
              },
            },
          },
        }),
      }
    )
      .then((response) => {
      })
      .catch((err) => {});
  }

  closeDrawer() {
    this.form.classList.remove("bisform--submitted");
    this.form.classList.remove("bisform--error");
    super.closeDrawer();
  }

  openDrawer() {
    this.form.classList.remove("bisform--submitted");
    this.form.classList.remove("bisform--error");
    super.openDrawer();
    this.emailInputField.focus();
  }

  cacheFormData() {
    this.form = this.querySelector("form");
    this.formData = new FormData(this.form);
  }

  setFormId() {
    this.form.querySelector('input[name="variant"]').value = this.variant_id;
    this.cacheFormData();
  }

  onFormSubmit(e) {
    e.preventDefault();

    if (this.hasNewsletterSignup) {
      this.newslettermailSignup();
    }

    this.bisSignup();
  }

  connectedCallback() {
    this.dispatchEvent(new CustomEvent("modal:loaded"));
    this.form = this.querySelector("form");
    this.emailInputField = this.form.querySelector('input[name="email"]');
    this.hasNewsletterSignup = false;

    if (this.querySelector("#bis-newsletter-signup")) {
      this.hasNewsletterSignup = true;
    }

    document.body.addEventListener("bis:trigger:click", (e) => {
      this.variant_id = e.detail.variant_id;
      this.form_bis = e.detail.form_bis;

      this.form.innerHTML = this.form_bis.innerHTML;
      this.form = this.querySelector('form');

      this.openDrawer();
      this.setFormId();
    });

    this.form.addEventListener("submit", (e) => {
      this.onFormSubmit(e);
    });
  }
}

customElements.define("bis-modal", BISModal);

class AsyncModal extends Drawer {
  constructor() {
    super();
  }

  openDrawer() {
    super.openDrawer();

    if (this.querySelector("modalusp-content")) {
      this.querySelector("modalusp-content").fetchContent();
    }
  }
}

customElements.define("async-modal", AsyncModal);
